import { api } from '../../lib/api';

export interface CertificateVerification {
  valid: true;
  serialNumber: string;
  issuedAt: string;
  studentName: string;
  courseName: string;
}

// Vérification publique d'un certificat via le code opaque encodé dans le QR code.
export async function verifyCertificate(
  code: string,
): Promise<CertificateVerification> {
  const { data } = await api.get(`/certificates/verify/${code}`);
  return data;
}
